import { render, staticRenderFns } from "./APIRoles.vue?vue&type=template&id=921ed5f0&"
import script from "./APIRoles.vue?vue&type=script&lang=js&"
export * from "./APIRoles.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports